export const ONBOARDING_CREATED_AD_ACCOUNT_ID_COOKIE = "sofaOnboardingCreatedAdAccountId";
export const ONBOARDING_CREATED_AD_ACCOUNT_ID_COOKIE_MAX_AGE_SECONDS = 10 * 60;
export const STATSIG_STABLE_ID_COOKIE = "tapestryStatsigStableId";
export const ADS_ATTRIBUTION_OPPREF_COOKIE = "__oppref";
export const COOKIE_BANNER_DISMISSED_COOKIE = "cookie_banner_dismissed";

type SofaCookieKey =
  | "analytics_consent"
  | "analytics_consent_source"
  | typeof ADS_ATTRIBUTION_OPPREF_COOKIE
  | typeof COOKIE_BANNER_DISMISSED_COOKIE
  | "marketing_consent"
  | "marketing_consent_source"
  | "personalization_consent"
  | "personalization_consent_source"
  | "oai-did"
  | "oai-locale"
  | "onboarding_campaign_setup_dismissed"
  | typeof ONBOARDING_CREATED_AD_ACCOUNT_ID_COOKIE
  | typeof STATSIG_STABLE_ID_COOKIE
  | "sofaLastAdAccountId"
  | "tapestry-theme";

export function getCookieFromHeader(cookieHeader: string, key: SofaCookieKey): string | undefined {
  try {
    const value = getRawCookieFromHeader(cookieHeader, key);
    return value === undefined ? undefined : decodeURIComponent(value);
  } catch (e) {
    console.warn(`Error parsing cookie header for key "${key}":`, e);
    return undefined;
  }
}

function getRawCookieFromHeader(cookieHeader: string, key: SofaCookieKey): string | undefined {
  const match = cookieHeader.match(new RegExp(`(?:^|; )${encodeURIComponent(key)}=([^;]*)`));
  return match?.[1];
}

export function getCookie(key: SofaCookieKey): string | undefined {
  if (typeof document === "undefined") return undefined;
  return getCookieFromHeader(document.cookie, key);
}

export function getRawCookie(key: SofaCookieKey): string | undefined {
  if (typeof document === "undefined") return undefined;
  return getRawCookieFromHeader(document.cookie, key);
}

export function setCookie(key: SofaCookieKey, value: string, options?: { maxAge?: number | null }) {
  // 2 years in seconds
  let cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  if (options?.maxAge !== null) {
    const maxAge = options?.maxAge ?? 2 * 365 * 24 * 60 * 60;
    cookie += `; Max-Age=${maxAge}`;
  }
  cookie += `; Path=/`;
  cookie += `; SameSite=Lax`;
  document.cookie = cookie;
}

export function deleteCookie(key: SofaCookieKey) {
  let cookie = `${encodeURIComponent(key)}=`;
  cookie += `; Max-Age=0`;
  cookie += `; Path=/`;
  cookie += `; SameSite=Lax`;
  document.cookie = cookie;
}
